import { ConfigFieldImport } from "pages/Components/ImportButton/ImportButton.types";
import {
  EmployeeGender,
  EmployeeMaterialStatus,
  EmployeeTaxObjectType,
  EmployeeType,
  EmploymentStatus,
} from "services";
import { i18n } from "translations";

export const ImportItemsConfigs: ConfigFieldImport[] = [
  {
    text: i18n.t("code"),
    type: "text",
    field: "code",
    width: 250,
    defaultText: "",
    required: true,
  },
  {
    text: i18n.t("email"),
    type: "text",
    field: "email",
    width: 250,
    regex: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
    defaultText: "test@email.com",
    required: true,
    errorMessage: "Email is invalid",
  },
  {
    text: i18n.t("phoneCode"),
    type: "text",
    field: "phoneCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("phoneNumber"),
    type: "text",
    field: "phoneNumber",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("firstName"),
    type: "text",
    field: "firstName",
    width: 250,
    defaultText: "",
    required: true,
  },
  {
    text: i18n.t("lastName"),
    type: "text",
    field: "lastName",
    width: 250,
    defaultText: "",
    required: true,
  },
  {
    text: i18n.t("birthdayDOB"),
    type: "date",
    field: "dateOfBirth",
    width: 250,
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("gender"),
    type: "text",
    field: "gender",
    width: 250,
    defaultText: `${Object.values(EmployeeGender).join("|")}`,
    regex: new RegExp(`^(${Object.values(EmployeeGender).join("|")})$`),
    errorMessage: "Gender is invalid",
    required: true,
  },
  {
    text: i18n.t("jobTitle"),
    type: "text",
    field: "title",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("jobTitle"),
    type: "text",
    field: "titleCode",
    width: 250,
    defaultText: "",
    required: true,
  },
  {
    text: i18n.t("materialStatus"),
    type: "text",
    field: "materialStatus",
    width: 250,
    defaultText: `${Object.values(EmployeeMaterialStatus).join("|")}`,
    regex: new RegExp(`^(${Object.values(EmployeeMaterialStatus).join("|")})$`),
    errorMessage: "Type is invalid",
  },
  {
    text: i18n.t("personalEmail"),
    type: "text",
    field: "personalEmail",
    width: 250,
    regex: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/,
    defaultText: "test@email.com",
    errorMessage: "Email is invalid",
  },
  {
    text: i18n.t("joinDate"),
    field: "firstWorkingDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("lastWorkingDate"),
    field: "lastWorkingDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("employeeType"),
    type: "text",
    field: "employmentType",
    width: 250,
    defaultText: `${Object.values(EmployeeType).join("|")}`,
    regex: new RegExp(`^(${Object.values(EmployeeType).join("|")})$`),
    errorMessage: "Type is invalid",
  },
  {
    text: i18n.t("status"),
    type: "text",
    field: "employmentStatus",
    width: 250,
    defaultText: `${Object.values(EmploymentStatus).join("|")}`,
    regex: new RegExp(`^(${Object.values(EmploymentStatus).join("|")})$`),
    errorMessage: "Type is invalid",
  },
  {
    text: i18n.t("isExpat"),
    type: "boolean",
    field: "isExpat",
    width: 250,
    defaultText: "true|false",
  },
  {
    text: i18n.t("probationStartDate"),
    field: "probationStartDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("probationPeriod"),
    field: "probationPeriod",
    width: 250,
    type: "text",
  },
  {
    text: i18n.t("probationEndDate"),
    field: "probationEndDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("contractNumber"),
    type: "text",
    field: "contractNo",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("contractStartDate"),
    field: "contractStartDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("contractEndDate"),
    field: "contractEndDate",
    width: 250,
    type: "date",
    defaultText: "YYYY-MM-DD",
    regex: /\d{4}-\d{2}-\d{2}/,
    errorMessage: "Date is invalid",
  },
  {
    text: i18n.t("contractNoticeBefore"),
    type: "number",
    field: "contractNoticePeriod",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("costCenter"),
    type: "text",
    field: "costCenter",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("payrollTemplate"),
    type: "text",
    field: "payrollTemplateId",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("taxCode"),
    type: "text",
    field: "taxCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("objectType"),
    type: "text",
    field: "taxObjectType",
    width: 250,
    defaultText: `${Object.values(EmployeeTaxObjectType).join("|")}`,
    regex: new RegExp(`^(${Object.values(EmployeeTaxObjectType).join("|")})$`),
    errorMessage: "Type is invalid",
  },
  {
    text: i18n.t("authorizeTaxFinalization"),
    type: "boolean",
    field: "isAuthorizeTaxFinalization",
    width: 250,
    defaultText: "true|false",
  },
  {
    text: i18n.t("department"),
    type: "text",
    field: "departmentCode",
    width: 250,
    defaultText: "",
    required: true,
  },
  {
    text: i18n.t("lineManager"),
    type: "text",
    field: "managerCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("hrbp"),
    type: "text",
    field: "hrbpCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("office"),
    type: "text",
    field: "branchCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("sideBarWorkLevel"),
    type: "text",
    field: "workLevelCode",
    width: 250,
    defaultText: "",
  },
  {
    text: i18n.t("contractType"),
    type: "text",
    field: "contractTypeCode",
    width: 250,
    defaultText: "",
  },
];
